import { Link } from "react-router-dom";
import { Instagram, Linkedin, Youtube } from "lucide-react";
import Logo from "./Logo";
import { BRAND } from "../data/content";

export default function Footer() {
  return (
    <footer data-testid="footer" className="relative bg-navy text-ivory grain pt-24 pb-10 overflow-hidden">
      <div className="max-w-[1500px] mx-auto px-6 md:px-10">
        <div className="gold-line mb-16" />
        <div className="grid md:grid-cols-12 gap-12">
          <div className="md:col-span-5">
            <Logo />
            <p className="text-ivory/60 mt-6 max-w-sm leading-relaxed text-[15px]">
              Crafting bespoke luxury journeys with personalised experiences and seamless travel planning, from beginning to end.
            </p>
          </div>
          <div className="md:col-span-2">
            <p className="overline text-gold/80 mb-5">Explore</p>
            <ul className="space-y-3 text-ivory/70 text-sm">
              <li><Link className="link-underline" to="/">Home</Link></li>
              <li><Link className="link-underline" to="/prive">Privé</Link></li>
              <li><Link className="link-underline" to="/collective">Collective</Link></li>
              <li><Link className="link-underline" to="/destinations">Destinations</Link></li>
              <li><Link className="link-underline" to="/about">About</Link></li>
            </ul>
          </div>
          <div className="md:col-span-2">
            <p className="overline text-gold/80 mb-5">Services</p>
            <ul className="space-y-3 text-ivory/70 text-sm">
              <li><Link className="link-underline" to="/prive">Luxury Tours</Link></li>
              <li><Link className="link-underline" to="/collective">Group Travel</Link></li>
              <li><Link className="link-underline" to="/enquire">Honeymoon</Link></li>
              <li><Link className="link-underline" to="/enquire">Cruises</Link></li>
            </ul>
          </div>
          <div className="md:col-span-3">
            <p className="overline text-gold/80 mb-5">Contact</p>
            <ul className="space-y-3 text-ivory/70 text-sm">
              <li>{BRAND.phone}</li>
              <li>{BRAND.email}</li>
              <li className="leading-relaxed">{BRAND.address}</li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://instagram.com" target="_blank" rel="noreferrer" className="text-ivory/70 hover:text-gold transition-colors"><Instagram size={18} /></a>
              <a href="https://linkedin.com" target="_blank" rel="noreferrer" className="text-ivory/70 hover:text-gold transition-colors"><Linkedin size={18} /></a>
              <a href="https://youtube.com" target="_blank" rel="noreferrer" className="text-ivory/70 hover:text-gold transition-colors"><Youtube size={18} /></a>
            </div>
          </div>
        </div>

        <div className="gold-line mt-16 mb-8" />
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-ivory/50 text-xs">
          <div className="flex gap-6">
            <Link className="hover:text-gold transition-colors" to="/legal/privacy">Privacy Policy</Link>
            <Link className="hover:text-gold transition-colors" to="/legal/terms">Terms &amp; Conditions</Link>
            <Link className="hover:text-gold transition-colors" to="/legal/refund">Refund &amp; Cancellation</Link>
          </div>
          <p>© 2026 End to End Destinations · Crafted for Extraordinary Journeys.</p>
        </div>
      </div>
    </footer>
  );
}
